// src/handlers/accountHandlers.js
// All user and account operations
import * as SupabaseService from '../supabaseService';

export const createAccountHandlers = (state) => {
  // Destructure only what is used to satisfy eslint no-unused-vars
  const {
    userForm, setUserForm,
    editingUser, setEditingUser,
    setShowUserModal,
    setAccount
  } = state;

  const handleSaveUser = async () => {
    if (editingUser) {
      const result = await SupabaseService.updateUser(editingUser.id, userForm);
      
      if (result.success) {
        setAccount(prev => ({
          ...prev,
          users: prev.users.map(u => u.id === editingUser.id ? { ...u, ...userForm } : u)
        }));
        
        setShowUserModal(false);
        setEditingUser(null);
        setUserForm({ name: '', email: '', role: 'Viewer' });
      } else {
        alert('Error updating user: ' + result.error);
      }
    } else {
      const result = await SupabaseService.addUser(userForm);
      
      if (result.success) {
        setAccount(prev => ({
          ...prev,
          users: [...prev.users, result.data]
        }));
        
        setShowUserModal(false);
        setUserForm({ name: '', email: '', role: 'Viewer' });
      } else {
        alert('Error adding user: ' + result.error);
      }
    }
  };

  const handleDeleteUser = async (userId) => {
    if (!window.confirm('Are you sure you want to delete this user?')) return;

    const result = await SupabaseService.deleteUser(userId);
    
    if (result.success) {
      setAccount(prev => ({
        ...prev,
        users: prev.users.filter(u => u.id !== userId)
      }));
    } else {
      alert('Error deleting user: ' + result.error);
    }
  };

  const handleOpenUserModal = (user = null) => {
    if (user) {
      setEditingUser(user);
      setUserForm({ name: user.name, email: user.email, role: user.role });
    }
    setShowUserModal(true);
  };

  const handleUpdateAccount = async (newAccount) => {
    const result = await SupabaseService.updateAccount(newAccount);
    
    if (result.success) {
      setAccount(newAccount);
    } else {
      alert('Error updating account: ' + result.error);
    }
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setAccount(prev => ({
          ...prev,
          profile: { ...prev.profile, logoUrl: reader.result }
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  return {
    handleSaveUser,
    handleDeleteUser,
    handleOpenUserModal,
    handleUpdateAccount,
    handleLogoUpload
  };
};